import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  initCreateAffiliateScreen,
  createAffiliate,
  editAffiliate,
  fetchAffiliateById,
  fetchCurrencyCodeDD,
  fetchAffiliateLocationWithAffiliateDD,
} from "../../../../redux/actions/Affiliate/affiliate";
import { fetchRateAdminNetworksDD } from "../../../../redux/actions/RateAdmin/rateadminNetworks";
import { useEffect } from "react";
import { setIsformDirty } from "../../../../redux/actions/common/form";
import CreateAffiliateComponent from "../../../../component/Affiliate/Affiliate/CreateAffiliate";
import { useParams } from "react-router-dom";

const CreateAffiliateContainer = (props) => {
  const {
    initCreateAffiliateScreen,
    createAffiliate,
    editAffiliate,
    isLoading,
    isCreateSuccess,
    isCreateError,
    isDetailSuccess,
    isDetailError,
    isEditSuccess,
    isEditError,
    isEdit,
    formFieldValueMap,
    fetchAffiliateById,
    shouldBlockNavigation,
    fetchNetworkDD,
    fetchCurrencyCodeDD,
    fetchAffiliateLocationWithAffiliateDD,
    locationDD,
    networkDD,
    currencyCodeDD,
  } = props;

  const { id } = useParams();

  useEffect(() => {
    const initScreen = async () => {
      initCreateAffiliateScreen();
      await fetchAffiliateLocationWithAffiliateDD(isEdit && id ? id : null);
      await fetchNetworkDD();
      fetchCurrencyCodeDD();
      if (isEdit && id) {
        fetchAffiliateById({ id });
      }
    };
    initScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, id]);

  useEffect(() => {
    if (isCreateSuccess || isEditSuccess) {
      shouldBlockNavigation(false);
    }
  }, [isCreateSuccess, isEditSuccess, shouldBlockNavigation]);

  const createAffiliateProps = {
    createAffiliate,
    editAffiliate,
    isLoading,
    isEdit,
    isDetailSuccess,
    isCreateSuccess,
    isEditSuccess,
    isEditError,
    formFieldValueMap,
    shouldBlockNavigation,
    locationDD,
    networkDD,
    currencyCodeDD,
  };

  const getToastProps = () => {
    if (isCreateSuccess || isEditSuccess) {
      const toastTitle = isEdit
        ? "Affiliate Updated Successfully"
        : "Affiliate Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (isCreateError || isDetailError || isEditError) {
      let toastTitle = "Error while Creating Affiliate";
      if (isEditError) {
        toastTitle = "Error while updating Affiliate";
      } else if (isDetailError) {
        toastTitle =
          "Error while performing operation. Please refresh your browser";
      }

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateAffiliateComponent {...createAffiliateProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectFromAffiliateReducer(state, "isLoading"),
    isCreateSuccess: selectFromAffiliateReducer(state, "isCreateSuccess"),
    isCreateError: selectFromAffiliateReducer(state, "isCreateError"),
    isDetailSuccess: selectFromAffiliateReducer(state, "isDetailSuccess"),
    isDetailError: selectFromAffiliateReducer(state, "isDetailError"),
    isEditSuccess: selectFromAffiliateReducer(state, "isEditSuccess"),
    isEditError: selectFromAffiliateReducer(state, "isEditError"),
    formFieldValueMap: selectFromAffiliateReducer(state, "formFieldValueMap"),
    locationDD: state.affiliateReducer?.affiliateLocationWithAffiliateDD || [],
    networkDD: selectFromNetworkReducer(state, "NetworksDD"),
    currencyCodeDD: state.affiliateReducer?.currencyCodeDD || [],
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateAffiliateScreen: () => dispatch(initCreateAffiliateScreen()),
    createAffiliate: (payload) => dispatch(createAffiliate(payload)),
    editAffiliate: (payload) => dispatch(editAffiliate(payload)),
    shouldBlockNavigation: (isFormDirty) => dispatch(setIsformDirty(isFormDirty)),
    fetchAffiliateById: (payload) => dispatch(fetchAffiliateById(payload)),
    fetchNetworkDD: (payload) => dispatch(fetchRateAdminNetworksDD(payload)),
    fetchCurrencyCodeDD: () => dispatch(fetchCurrencyCodeDD()),
    fetchAffiliateLocationWithAffiliateDD: (affiliateId) => dispatch(fetchAffiliateLocationWithAffiliateDD(affiliateId)),
  };
};

const selectFromAffiliateReducer = (state, path) => {
  return selectAffiliateReducer(state)?.[path];
};

const selectAffiliateReducer = ({ affiliateReducer }) => {
  return affiliateReducer;
};

const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)?.[path];
};

const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};

const selectFromNetworkReducer = (state, path) => {
  return selectNetworkReducer(state)?.[path];
};

const selectNetworkReducer = ({ rateadminNetworksReducer }) => {
  return rateadminNetworksReducer;
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAffiliateContainer);
